let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lOkkf")).then(() => parcelRequire('2AT3N'));